// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__oyFFV","mainBodyWrapper":"style_mainBodyWrapper__5oAm3"};